/** GraphElement registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseGraphElement } from './parser';
const graphElementRegistration = {
    typeName: 'GraphElement',
    parser: parseGraphElement,
};
nodeRegistry.register(graphElementRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map